/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Timeline from "../../Charts/Timeline";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface IPlacementRateProps {
  placementRate: {
    months?: Date[];
    values?: number[];
  };
  placementRateWidgetLoader: boolean;
}

export class PlacementRate extends Component<IPlacementRateProps> {
  static propTypes = {
    placementRate: PropTypes.shape({
      months: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      values: PropTypes.arrayOf(PropTypes.number),
    }),
    placementRateWidgetLoader: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    placementRate: {
      months: [],
      values: [],
    },
  };
  render(): ReactNode {
    const { placementRate, placementRateWidgetLoader } = this.props;

    const placementRateOptions = {
      series: [
        {
          name: "Placement Rate",
          data: placementRate.values,
        },
      ],
      options: {
        colors: ["#673490"],
        height: 350,
        chart: {
          type: "line",
          offsetY: -5,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [1],
          curve: "straight",
        },
        markers: {
          size: 5,
          radius: 5,
          shape: "circle",
        },

        tooltip: {
          x: {
            formatter: function (value) {
              const date = new Date(value);
              return date.toLocaleString("default", { month: "short" });
            },
          },
          y: [
            {
              title: {
                formatter: (val: string) => val,
              },
            },
          ],
        },
        xaxis: {
          type: "datetime",
          categories: placementRate.months.map((date) => date.getTime()),
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "%",
          },
          labels: {
            show: true,
            // formatter: function (val) {
            //   return val + "%";
            // },
          },
        },
        legend: {
          offsetY: 5,
          tooltipHoverFormatter: (
            val: string,
            opts: {
              // I've typed the opts manually because ApexCharts seem to have
              // typed this as 'any' which our lint config doesn't like
              // (at the time of writing, anyway) see
              // https://github.com/apexcharts/apexcharts.js/blob/master/types/apexcharts.d.ts#L744
              w: {
                globals: { series: number[][] };
              };
              seriesIndex: number;
              dataPointIndex: number;
            }
          ) => {
            const value = `${val} - ${
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]
            } `;
            return value;
          },
        },
      },
    };

    return (
      <Fragment>
        <Wrapper className="animated fadeIn delay-5" id="placement-rate-widget">
          <AnalyticsWidgetLoading
            text="Updating..."
            active={placementRateWidgetLoader}
          />

          <Timeline
            graphOptions={placementRateOptions}
            dataTestId="placements-rate-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="placement-rate-per-sector-title"
            data-tip=" Percentage of placements made versus roles posted."
            data-for="placement-rate-per-sector-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="placement-rate-per-sector-title-tooltip"
              className="tooltip-max-width"
            />
            Placement Rate
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    jobPerformanceData: {
      placementRate: {
        months: Date[];
        values: number[];
      };
    };
    placementRateWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  placementRate: state.employerAnalytics.jobPerformanceData.placementRate,
  placementRateWidgetLoader: state.employerAnalytics.placementRateWidgetLoader,
});

export default connect(mapStateToProps, {})(PlacementRate);
